
import React from 'react';
import { FileText } from 'lucide-react';
import ReferralTemplateForm from '@/components/ReferralTemplateForm';
import { ReferralTemplateConfig, ReferralURLConfig } from '@/utils/config/types';

interface TemplateSettingsTabProps {
  templates: ReferralTemplateConfig[];
  urls: ReferralURLConfig[];
  onSaved: () => void;
}

const TemplateSettingsTab: React.FC<TemplateSettingsTabProps> = ({ 
  templates, 
  urls,
  onSaved 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <FileText className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold">Referral Templates</h2>
      </div>
      <ReferralTemplateForm 
        templates={templates}
        urls={urls}
        onSaved={onSaved} 
      />
    </div>
  );
};

export default TemplateSettingsTab;
